import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "settings-cash-drawer mt-1 mb-3"
};
var _hoisted_2 = {
  class: "mb-1"
};
var _hoisted_3 = {
  class: "item-name"
};
var _hoisted_4 = {
  class: "item-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("settings.cash-drawer-and-receipts")), 1), _createVNode(_component_el_form, {
    model: _ctx.formData,
    "label-position": "top",
    "label-width": "120px",
    "hide-required-asterisk": true,
    class: "setting-items"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("completeorder.print-receipt")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.autoPrintReceipt ? 'primary' : 'default',
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.toggleAutoPrintReceipt(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.auto")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: _ctx.autoPrintReceipt ? 'default' : 'primary',
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.toggleAutoPrintReceipt(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.manual")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("button.open-drawer")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.selectedOption,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _ctx.selectedOption = $event;
                    }),
                    placeholder: _ctx.$t('button.open-drawer')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsArray, function (option) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: option.value,
                          label: option.label,
                          value: option.value
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"])]);
}